import * as Vest from 'vest';
import 'vest/enforce/compounds';

export const FormSuite = Vest.create((data = {}) => {

    Vest.test('BirthDate','ERROR_FORMAT_DDMMYYYY', () => {
        return true;
    });
});